import pendingPromise from 'utils/pendingPromise';

const genCallbackName = () => 'cb_' + Date.now() + '_' + ~~(Math.random() * 10000);
export default function(url, options = {}) {
	let callbackArg = options.callbackArg || 'callback';
	let callbackName = options.callbackName || genCallbackName();
	url += (url.includes('?') ? '&' : '?') + callbackArg + '=' + callbackName;
	let script = document.createElement('script');
	let promise = pendingPromise();
	let ran = false;
	window[callbackName] = (data) => {
		ran = true;
		promise.resolve(data);
		script.remove();
	};
	script.addEventListener('error', (err) => {
		promise.reject(err || new Error('Unable to load JSONP at ' + url));
		script.remove();
	});
	script.addEventListener('load', () => {
		if (!ran) {
			promise.reject(new Error('Not proper JSONP at ' + url));
			script.remove();
		}
	});
	script.src = url;
	document.body.appendChild(script);
	return promise;
}
